import React, {useEffect} from "react";
import {useLocation} from "react-router-dom"
import {
    Stack,
    Box,
    TextBlock,
} from "@unibuddy/patron";
import {
    AUTH_FLOW_TIMEOUT as TIMEOUT
} from "ubcommunity-shared/src/constants";

function appendStateToUrlSearchParams (originalUrl: string, state: string) {
    const url = new URL(originalUrl);
    const {
        searchParams
    } = url;
    searchParams.append('state', state);
    return url.toString();
}

export default function LoginBump ({ redirectUrl }) {
    const {pathname, search} = useLocation();
    const url = appendStateToUrlSearchParams(redirectUrl, pathname + search)

    useEffect(() => {
        if (TIMEOUT) {
            const timeoutID = setTimeout(() => {
                window.location.replace(url)
            }, TIMEOUT)

            return () => {
                if (timeoutID) clearTimeout(timeoutID)
            }
        }

        window.location.replace(url)
    })

    return (
        <Box
            minW={["100%", "100%", 0]}
            padding={["medium", "medium", "large"]}
            paddingTop={["medium", "medium", "large"]}>
            <Stack space="xlarge">
                <Stack>
                    <TextBlock size="large" weight="bold">
                        We shall now redirect you to your authentication provider
                    </TextBlock>
                </Stack>
            </Stack>
        </Box>
    )
}
